module.exports = __webpack_public_path__ + "img/activities-1.d88e8ef2.jpg";